var map = {
	"./logo-1.gif": 159,
	"./logo-2.gif": 160,
	"./logo-3.gif": 161,
	"./logo-4.gif": 162,
	"./logo-5.gif": 163,
	"./logo-6.gif": 164,
	"./logo-7.gif": 165,
	"./logo-8.gif": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 572;



/*****************
 ** WEBPACK FOOTER
 ** ./src/site/images ^\.\/logo\-.*\.gif$
 ** module id = 572
 ** module chunks = 0
 **/